import { render, staticRenderFns } from "./SongWaveSurfer.vue?vue&type=template&id=9cbbb8be"
import script from "./SongWaveSurfer.vue?vue&type=script&lang=js"
export * from "./SongWaveSurfer.vue?vue&type=script&lang=js"
import style0 from "./SongWaveSurfer.vue?vue&type=style&index=0&id=9cbbb8be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports